import { queryOptions } from "@tanstack/react-query";
import type { UsageResponse } from "@/app/billing/types";
import { getCoordinatorApi } from "@/lib/api";
import { billingKeys } from "./query-keys";

export type UsageQueryParams = {
  granularity?: "day";
  timeframe_start?: string;
  timeframe_end?: string;
  view_mode?: "periodic" | "cumulative";
  from?: number;
  to?: number;
};

const fetchUsage = async ({
  organizationId,
  params,
}: {
  organizationId: string;
  params?: UsageQueryParams;
}): Promise<UsageResponse> => {
  const api = getCoordinatorApi({ organizationId });
  const paramsWithDefaults: UsageQueryParams = {
    view_mode: "periodic",
    ...params,
  };
  const { data } = await api.get<UsageResponse>("/billing/subscription/usage", {
    params: paramsWithDefaults,
  });

  return data;
};

export const usageQueryOptions = ({
  organizationId,
  params,
}: {
  organizationId: string;
  params?: UsageQueryParams;
}) =>
  queryOptions<UsageResponse>({
    queryKey: billingKeys.usage(organizationId, params),
    queryFn: () => fetchUsage({ organizationId, params }),
  });
